import { http } from '../services';

class AvaliadoresProjetoService {
    avaliadoresProjetoForm() {
        return http.get('/avaliadoresprojeto/form');
    }

    async getAvaliadoresProjeto(projeto) {
        return http.get('/avaliadoresprojeto', {
            projeto,
        });
    }

    async getAcompanharAvaliador(subevento, area) {
        return http.get('/acompanhar-avaliador', {
            subevento,
            area,
        });
    }

    delete(projeto, avaliador) {
        return http.delete('/avaliadoresprojeto', {
            projeto,
            avaliador,
        });
    }

    save(projeto, avaliador) {
        return http.post('/avaliadoresprojeto', {
            projeto,
            avaliador,
        });
    }

    notificarPorEmail(projeto) {
        return http.get('/avaliadoresprojeto/notificar-por-email', {
            projeto,
        });
    }
}

const avaliadoresProjetoService = new AvaliadoresProjetoService();
export default avaliadoresProjetoService;
